import React from 'react'; 
import Home from './Home';
import Navbar from './Navbar';
import About from './About';
import Project from './Project';
import Contact from './Contact';
import Service from './Service';
import Education from './Education';
import AllProjects from './Pages/allProjects';
import ServicesPage from './Pages/Services';
import NotFound from './Pages/NotFound';
import Footer from './Footer';
import ScrollToTop from './utils/Scroll';
import LoaderWrapper from './utils/Loader';
import ProcessSection from './Section/ProcessSection';
import { Toaster } from 'sonner';
import { useLocation, Routes, Route } from 'react-router-dom';
import Hire from './Hire-me';

function AppLayout() {
  const location = useLocation();

  const validRoutes = [
    "/",
    "/allProjects",
    "/services-page",
    "/process",
    "/about",
    "/services",
    "/portfolio",
    "/hire",
    "/education",
    "/contact",
  ];

  const showLayout = validRoutes.includes(location.pathname);

  return (
    <LoaderWrapper>
      <Toaster richColors position="top-right" />
      <ScrollToTop />

      {showLayout && <Navbar />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/allProjects" element={<AllProjects />} />
        <Route path="/services-page" element={<ServicesPage />} />
        <Route path="/process" element={<ProcessSection />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Service />} />
        <Route path="/portfolio" element={<Project />} />
        <Route path="/hire" element={<Hire />} />
        <Route path="/education" element={<Education />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

      {showLayout && <Footer />}
    </LoaderWrapper>
  );
}

export default AppLayout;